import cart from "assets/header/cart.svg";
import wishlistFilled from "assets/header/wishlist-filled.svg";
import wishlist from "assets/header/wishlist.svg";
import { ALL_PRODUCTS, SEARCH_PARAMS } from "utils/constants/route.constants";

export const drawerWidth = 240;
export const navItems = [
  {
    title: "Home",
    link: "/",
    index: 1,
    notVisible: [],
  },
  {
    title: "Shop",
    link: `/our-shop/all?${SEARCH_PARAMS.categoryId}=${ALL_PRODUCTS}&${SEARCH_PARAMS.query}=`,
    index: 3,
    notVisible: ["/"],
  },
  {
    title: "Our Story",
    link: "/our-story",
    index: 4,
    notVisible: [],
  },
];

export const Icons = [
  { src: wishlist, alt: "wishlist", filledIcon: wishlistFilled },
  { src: cart, alt: "cart" },
];
